import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-56712d4e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "deep"
};
var _hoisted_2 = {
  class: "top"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" Riscern Pro ");

var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = {
  key: 1
};
var _hoisted_6 = {
  key: 2
};
var _hoisted_7 = {
  class: "info"
};
var _hoisted_8 = {
  key: 0,
  class: "tip-date"
};
var _hoisted_9 = {
  key: 1,
  class: "tip-date"
};

var _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div data-v-56712d4e><div class=\"item\" data-v-56712d4e><span class=\"high-text\" data-v-56712d4e></span>Company Pro Dataset</div><div class=\"item\" data-v-56712d4e><span class=\"high-text\" data-v-56712d4e></span>Up to 1200 companies a year</div><div class=\"item\" data-v-56712d4e><span class=\"high-text\" data-v-56712d4e></span>Export company information</div><div class=\"item\" data-v-56712d4e><span class=\"high-text\" data-v-56712d4e></span>Monitor up to 20 companies</div></div>", 1);

var _hoisted_11 = {
  class: "payment"
};
var _hoisted_12 = {
  key: 0,
  class: "payment-content"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "name"
  }, "Payment", -1);
});

var _hoisted_14 = {
  class: "value"
};
var _hoisted_15 = {
  class: "update"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", null, null, -1);
});

var _hoisted_17 = {
  class: "value"
};
var _hoisted_18 = {
  class: "date"
};
var _hoisted_19 = {
  key: 2,
  class: "change-plan"
};

var _hoisted_20 = /*#__PURE__*/_createTextVNode(" Change Plan ");

var _hoisted_21 = {
  key: 3
};
var _hoisted_22 = {
  class: "change-plan"
};

var _hoisted_23 = /*#__PURE__*/_createTextVNode(" Renew Pro ");

var _hoisted_24 = {
  key: 4,
  class: "change-plan current"
};
var _hoisted_25 = {
  class: "price"
};

var _hoisted_26 = /*#__PURE__*/_createTextVNode(" Select ");

import ProDialog from './ProDialog.vue';
import { computed } from 'vue';
import { formatTime } from '@/utils/time';
import { renewProVisible, changePlanStatus, updateVisible } from '../data';
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  props: {
    currentData: Object,
    userCardData: Object,
    status: String,
    initData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var router = useRouter(); // change-Plan状态

    var currentPageStatus = computed(function () {
      return route.name === 'InformationChangePlan';
    });

    function onHrefResourcesPlans() {
      router.push({
        name: 'ResourcesPlans'
      });
    } // 已订阅


    var userSubscribed = computed(function () {
      var _ref = props.currentData || {},
          subscribeStatus = _ref.subscribeStatus;

      return !currentPageStatus.value && [2].includes(subscribeStatus);
    }); // 订阅中 / 升级中

    var userSubscribIng = computed(function () {
      var _ref2 = props.currentData || {},
          subscribeStatus = _ref2.subscribeStatus;

      return !currentPageStatus.value && [1, 5].includes(subscribeStatus);
    });
    var userCancel = computed(function () {
      var _ref3 = props.currentData || {},
          subscribeStatus = _ref3.subscribeStatus;

      return !currentPageStatus.value && [4].includes(subscribeStatus);
    });

    function handleRenew() {
      renewProVisible.value = true;
    }

    function handleChangePlan() {
      router.push({
        name: 'InformationChangePlan'
      });
    }

    function handleSelect() {
      changePlanStatus.value = 1;
      document.documentElement.scrollTop = 0;
    }

    function onClickUpdate() {
      updateVisible.value = true;
    }

    return function (_ctx, _cache) {
      var _props$currentData, _props$currentData2, _props$currentData3, _props$userCardData, _props$userCardData2;

      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, __props.currentData.isTrial ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Trial")) : _createCommentVNode("", true), _unref(userCancel) ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Cancelled")) : _createCommentVNode("", true), _unref(userSubscribIng) ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Payment processing")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_unref(userCancel) ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString("Your plan will change to Riscern Free on ".concat(_unref(formatTime)((_props$currentData = __props.currentData) === null || _props$currentData === void 0 ? void 0 : _props$currentData.endTime))), 1)) : __props.currentData.isTrial ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString("Your plan will be charged for Riscern Pro on ".concat(_unref(formatTime)((_props$currentData2 = __props.currentData) === null || _props$currentData2 === void 0 ? void 0 : _props$currentData2.endTime), ", unless you cancel prior to such date.")), 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "list"
      }, [_hoisted_10, _createElementVNode("div", {
        class: "high-text more",
        onClick: onHrefResourcesPlans
      }, "Learn More")]), _createElementVNode("div", _hoisted_11, [_unref(userSubscribed) || _unref(userSubscribIng) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, "Your next bill is for " + _toDisplayString(__props.initData.proPrice) + " USD on " + _toDisplayString(_unref(formatTime)((_props$currentData3 = __props.currentData) === null || _props$currentData3 === void 0 ? void 0 : _props$currentData3.endTime)) + ".", 1), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, "Card ending in " + _toDisplayString((_props$userCardData = __props.userCardData) === null || _props$userCardData === void 0 ? void 0 : _props$userCardData.cardNo), 1), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", null, "Expires: " + _toDisplayString((_props$userCardData2 = __props.userCardData) === null || _props$userCardData2 === void 0 ? void 0 : _props$userCardData2.expireDate), 1), _createElementVNode("div", {
        class: "high-text",
        onClick: onClickUpdate
      }, "Update")])])])) : _createCommentVNode("", true)]), _unref(userSubscribed) ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_button, {
        type: "primary",
        class: "project-btn bottom-btn",
        onClick: handleChangePlan
      }, {
        default: _withCtx(function () {
          return [_hoisted_20];
        }),
        _: 1
      })])) : _createCommentVNode("", true), _unref(userCancel) ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_button, {
        type: "primary",
        class: "project-btn bottom-btn",
        onClick: handleRenew
      }, {
        default: _withCtx(function () {
          return [_hoisted_23];
        }),
        _: 1
      })])])) : _createCommentVNode("", true), _unref(currentPageStatus) ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(__props.initData.proPrice) + " USD/month", 1), __props.status === 'available' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        class: "project-btn bottom-btn",
        onClick: handleSelect
      }, {
        default: _withCtx(function () {
          return [_hoisted_26];
        }),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createVNode(ProDialog, {
        initData: __props.initData,
        currentData: __props.currentData
      }, null, 8, ["initData", "currentData"])]);
    };
  }
});